function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(50 50)"
}, React.createElement("g", {
  transform: "scale(0.7)"
}, React.createElement("g", {
  transform: "translate(-50 -50)"
}, React.createElement("g", {
  transform: "rotate(302.553 50 50)"
}, React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  repeatCount: "indefinite",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1",
  dur: "0.7575757575757576s"
}), React.createElement("path", {
  fillOpacity: 0.8,
  fill: "#907c26",
  d: "M50 50L50 0A50 50 0 0 1 100 50Z"
})), React.createElement("g", {
  transform: "rotate(226.915 50 50)"
}, React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  repeatCount: "indefinite",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1",
  dur: "1.0101010101010102s"
}), React.createElement("path", {
  fillOpacity: 0.8,
  fill: "#002bff",
  d: "M50 50L50 0A50 50 0 0 1 100 50Z",
  transform: "rotate(90 50 50)"
})), React.createElement("g", {
  transform: "rotate(151.277 50 50)"
}, React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  repeatCount: "indefinite",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1",
  dur: "1.5151515151515151s"
}), React.createElement("path", {
  fillOpacity: 0.8,
  fill: "#7cff00",
  d: "M50 50L50 0A50 50 0 0 1 100 50Z",
  transform: "rotate(180 50 50)"
})), React.createElement("g", {
  transform: "rotate(75.6383 50 50)"
}, React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  repeatCount: "indefinite",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1",
  dur: "3.0303030303030303s"
}), React.createElement("path", {
  fillOpacity: 0.8,
  fill: "#01ffc5",
  d: "M50 50L50 0A50 50 0 0 1 100 50Z",
  transform: "rotate(270 50 50)"
})))));

var SvgLoadingicon = function SvgLoadingicon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLoadingicon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loadingicon.e969276a.svg";
export { ForwardRef as ReactComponent };